import React, { useState, useEffect } from 'react';
/* eslint-disable */
import * as Yup from 'yup';

// material
import { Container, Card } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';

import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, InputAdornment, Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';

//table start


const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

//table end

function createData(name, crop, remainignQty) {
  return { name, crop, remainignQty };
}

const rows = [
  createData('Thanamalvila', 'Ash Plantain', 50),
  createData(<TableCell align="left" style={{ fontWeight: 'bold' }}>Total</TableCell>, '', <strong> 100</strong>
  ),
];

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});



export default function ViewInvoiceCollectionWise(props) {
  const classes = useStyles();

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('ashPlantain');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
  //Table finish

  const [productList, setProductList] = useState([]);
  const [productcatogery, setProductcatogery] = useState([]);
  const [isTable, setIsTable] = useState(false);

  const [date, setDate] = useState(new Date());

  let encrypted = '';
  const navigate = useNavigate();

  const productcatogerySearchSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
    ddl: Yup.number().min(1, 'Please Select Operation Entity').required('Operation Entity Required'),
    // collectionCenter: Yup.number().min(1, 'Please Select Crop').required('Crop Required'),
    date: Yup.date().notRequired()
  });

  const formik = useFormik({
    initialValues: {
      groupID: '1',
      ddl: '1',
      collectionCenter: '0',
      dateID: date.toISOString().split('T')[0],
    },
    validationSchema: productcatogerySearchSchema,
    onSubmit: (values) => {
      SubmitForm(values);
    }
  });

  async function SubmitForm(value) {
    await timeout(1000);
    setIsTable(true);
  }

  async function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  return (
    <Page title="Product Creation |  FAPS">
      <Container>
        <CommonPageHeader
          path={'/createCropForcast'}
          btname="Add"
          pageName="Collection Center Wise Return Invoice Report "
          leftButtonHidden={true}
        />

        <FormikProvider value={formik}>
          <ToastContainer position="bottom-right" pauseOnHover />
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Stack spacing={2}>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Group *"
                  value={formik.values.groupID}
                  onChange={formik.handleChange}
                  {...getFieldProps('groupID')}
                  error={Boolean(touched.groupID && errors.groupID)}
                  helperText={touched.groupID && errors.groupID}
                >
                  <MenuItem key={0} value={0}>
                    {' '}
                    Select Group
                  </MenuItem>
                  <MenuItem value={1}> Cargills</MenuItem>
                </TextField>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Operation Entity *"
                  value={formik.values.ddl}
                  onChange={formik.handleChange}
                  {...getFieldProps('ddl')}
                  error={Boolean(touched.ddl && errors.ddl)}
                  helperText={touched.ddl && errors.ddl}
                >
                  <MenuItem key={0} value={0}>
                    {' '}
                    Operation Entity
                  </MenuItem>
                  <MenuItem value={1}> Cargills</MenuItem>
                </TextField>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Crop *"
                  value={formik.values.collectionCenter}
                  onChange={formik.handleChange}
                  {...getFieldProps('collectionCenter')}
                  error={Boolean(touched.collectionCenter && errors.collectionCenter)}
                  helperText={touched.collectionCenter && errors.collectionCenter}
                >
                  <MenuItem key={0} value={0}>All</MenuItem>
                  <MenuItem value={1}> Ash Plantain</MenuItem>
                  <MenuItem value={2}> Crop</MenuItem>
                </TextField>
                <TextField
                  fullWidth
                  size="small"
                  id="date"
                  label="Date"
                  type="date"
                  value={formik.values.dateID}
                  onChange={formik.handleChange}
                  {...getFieldProps('dateID')}
                  error={Boolean(touched.dateID && errors.dateID)}
                  helperText={touched.dateID && errors.dateID}
                  InputProps={{
                    startAdornment: <InputAdornment position="start"></InputAdornment>
                  }}
                />
              </Stack>
            </Stack>
            <br />
            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
              <Button type="submit" color="secondary" variant="outlined">
                Search
              </Button>
            </Stack>
          </Form>
        </FormikProvider>

        <br />
        <Divider variant="middle" />
        <br />
        {/* TAble  */}


        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <Card style={{ justifycontent: 'center', width: '100rem' }}>
            <Paper className={classes.paper}>


              <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" }}>Collection Center</TableCell>
                      <TableCell align="right" style={{ fontWeight: "bold" }}>Crop</TableCell>
                      <TableCell align="right" style={{ fontWeight: "bold" }}>Remainig Qty(Kg)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row) => (
                      <StyledTableRow key={row.name}>
                        <TableCell component="th" scope="row">
                          {row.name}
                        </TableCell>
                        <TableCell align="right">{row.crop}</TableCell>
                        <TableCell align="right">
                          {row.remainignQty}
                        </TableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Card>
        </Stack>

        <br />

        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
          <Button type="submit" color="secondary" variant="outlined">
            PDF
          </Button>
          <Button type="submit" color="secondary" variant="outlined">
            Excel
          </Button>
        </Stack>
      </Container>
    </Page>
  );
}
